import React, { useEffect } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { compactAppCache, pruneExpiredAppCache } from '../utils/cacheManager';

const PENDING_CHECKOUT_PLAN_KEY = 'pending_checkout_plan_key';

const normalizeAuth0Domain = (value) => String(value || '')
  .trim()
  .replace(/^https?:\/\//i, '')
  .replace(/\/$/, '');

const Auth0ProviderWithNavigate = ({ children }) => {
  const runtimeEnv = window.__RUNTIME_ENV__ || {};
  const domain = normalizeAuth0Domain(runtimeEnv.AUTH0_DOMAIN || process.env.REACT_APP_AUTH0_DOMAIN || '');
  const clientId = runtimeEnv.AUTH0_CLIENT_ID || process.env.REACT_APP_AUTH0_CLIENT_ID || '';
  const audience = runtimeEnv.AUTH0_AUDIENCE || process.env.REACT_APP_AUTH0_AUDIENCE || '';
  const redirectUri = window.location.origin;

  useEffect(() => {
    try {
      pruneExpiredAppCache();
      compactAppCache(12);
    } catch (error) {
      console.error('Failed to compact app cache before auth init:', error);
    }
  }, []);

  if (!domain || !clientId) {
    console.error('Auth0 configuration missing');
    return <>{children}</>;
  }

  const onRedirectCallback = (appState) => {
    const checkoutPlanKey = appState?.checkoutPlanKey;
    if (checkoutPlanKey) {
      window.sessionStorage.setItem(PENDING_CHECKOUT_PLAN_KEY, String(checkoutPlanKey));
    }

    const target = appState?.returnTo || window.location.pathname;
    window.history.replaceState({}, document.title, target);
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      onRedirectCallback={onRedirectCallback}
      authorizationParams={{
        redirect_uri: redirectUri,
        ...(audience ? { audience } : {}),
        scope: 'openid profile email',
      }}
      cacheLocation="localstorage"
      useCookiesForTransactions={true}
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithNavigate;
